import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBaking: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="baking, cooking"><path d="M13 8.25C8.45934 11.1551 15.5407 12.8449 11 15.75" stroke="currentColor" strokeWidth="1.5"/><path d="M8.75 8.25C4.20934 11.1551 11.2907 12.8449 6.75 15.75" stroke="currentColor" strokeWidth="1.5"/><path d="M17.25 8.25C12.7093 11.1551 19.7907 12.8449 15.25 15.75" stroke="currentColor" strokeWidth="1.5"/><path d="M21.25 4.75H2.75V19.25H21.25V4.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconBaking;
